import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageAware } from 'src/app/general/language-aware';
import { UserFindPopupComponent } from 'src/app/popups/user-find-popup/user-find-popup.component';
import { PopupService } from 'src/app/services/popup.service';

@Component({
  selector: 'app-cp-filtered-users',
  templateUrl: './cp-filtered-users.component.html',
  styleUrls: ['./cp-filtered-users.component.scss'],
})
export class CpFilteredUsersComponent extends LanguageAware implements OnInit {
  constructor(cdRef: ChangeDetectorRef, private router: Router, private pp: PopupService) {
    super(cdRef);
    this.headerBar.showHeader({
      showLogo: true,
      backUrl: this.g.getHomeUrl().join('/') + '/all-users',
    });
    this.background.setGray();
    const that = this;
    this.headerBar.onBackClicked = () => {
      that.us.filteredUsers = [];
    };
  }

  ngOnInit(): void {}

  public openFind() {
    this.pp.openPopup(UserFindPopupComponent, { attachToClass: 'mobile-app' });
  }

  public close() {
    this.us.filteredUsers = [];
    this.router.navigate([...this.g.getHomeUrl(), 'all-users']);
  }

  public editUser(userId: number) {
    this.router.navigate([...this.g.getHomeUrl(), 'edit-user', userId, 'filter']);
  }
}
